/**
 * 画像ロード関数
 * @param params string- 画像パス
 */
export const loadingImage = (path: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = (e) => reject(e)
    img.src = path
  })
}
